<div class="container mx-auto shadow-md rounded-lg relative max-w-[90vw] xl:max-w-[70rem]">
  <img
    src="assets/images/logos/company_logo_icon.svg"
    alt="Add Codi Logo"
    class="max-w-full h-auto absolute pt-3 ps-2 rounded-lg" />

  <div class="grid lg:grid-cols-2 grid-cols-1 justify-center items-center login-box">
    <div class="lg:py-3">
      <div class="md:p-[4rem] p-4">
        <div class="flex justify-center">
          <i
            class="pi pi-shield w-[42px] h-[42px] border border-neutral-200 rounded-[10px] flex! items-center justify-center bg-[linear-gradient(180deg,#FFFFFF_0%,#F1F1F1_115.48%)]"></i>
        </div>

        <div class="pt-3 text-center">
          <span class="text-xl font-semibold text-neutral-900">Admin Panel Login</span>
          <span class="text-sm text-neutral-500 block">Sign in with your admin credentials</span>
        </div>

        <form [formGroup]="loginForm" class="flex flex-col gap-4 pt-4" (ngSubmit)="onLogin()">
          <div class="flex flex-col">
            <label class="form-theme-label text-xs!" for="email">Email</label>
            <input
              pInputText
              id="email"
              formControlName="email"
              pSize="small"
              placeholder="Enter email" />
            @if (loginForm.controls.email.touched && loginForm.controls.email.invalid) {
              <span class="form-error">Please enter a valid email address.</span>
            }
          </div>

          <div class="flex flex-col relative">
            <label class="form-theme-label text-xs!" for="password">Password</label>
            <div class="relative">
              <input
                [type]="hidePassword() ? 'password' : 'text'"
                pInputText
                id="password"
                formControlName="password"
                pSize="small"
                placeholder="Enter password" />
              <i
                (click)="onPasswordShowToggle()"
                class="pi absolute right-[10px] top-[50%] translate-y-[-50%] cursor-pointer"
                [ngClass]="hidePassword() ? 'pi-eye' : 'pi-eye-slash'"></i>
            </div>
            @if (loginForm.controls.password.touched && loginForm.controls.password.invalid) {
              <span class="form-error">Password must be at least 8 characters.</span>
            }
          </div>

          @if (errorMessage()) {
            <div class="inline-error-box">
              {{ errorMessage() }}
            </div>
          }

          <div>
            <p-button
              type="submit"
              class="w-100-button"
              [raised]="true"
              [disabled]="!loginForm.valid || loading()">
              @if (!loading()) {
                <span>Sign In</span>
              } @else {
                <span class="flex items-center justify-center gap-1">
                  <i class="pi pi-spin pi-spinner"></i>
                  <span class="leading-none">Signing in...</span>
                </span>
              }
            </p-button>
          </div>
        </form>
      </div>

      <div class="auth-footer lg:absolute lg:w-1/2 bottom-0 lg:left-0 px-4 lg:pb-2 pb-2">
        <span class="text-xs text-neutral-500">© MyCodi. All rights reserved.</span>
      </div>
    </div>

    <div class="px-0 lg:block hidden">
      <img
        src="assets/images/backgrounds/login_frame.png"
        alt="Login Background"
        class="max-w-full h-auto rounded-lg" />
    </div>
  </div>
</div>
